// Lightweight backend prewarm utility
// Pings the backend root to wake up the instance (e.g., Render) without blocking the UI

export async function prewarmBackend(tag = 'init') {
  try {
    const apiUrl = process.env.REACT_APP_API_URL;
    if (!apiUrl) {
      // No API URL configured; nothing to prewarm
      return;
    }

    // Abort after ~4.5s to avoid hanging
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 4500);

    // Use no-store to avoid cache
    await fetch(`${apiUrl}/`, {
      method: 'GET',
      cache: 'no-store',
      mode: 'cors',
      signal: controller.signal,
      headers: {
        'X-Prewarm': `hairalyze-${tag}`,
      },
    }).catch(() => {
      // Swallow errors; this is best-effort only
    }).finally(() => {
      clearTimeout(timeoutId);
    });
  } catch (_) {
    // Ignore any unexpected errors
  }
}

